// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['sv_SE']  = {
  "name": "sv_SE",
  "day": {
    "abbrev": [
      "sön",
      "mån",
      "tis",
      "ons",
      "tor",
      "fre",
      "lör"
    ],
    "full": [
      "söndag",
      "måndag",
      "tisdag",
      "onsdag",
      "torsdag",
      "fredag",
      "lördag"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "januari",
      "februari",
      "mars",
      "april",
      "maj",
      "juni",
      "juli",
      "augusti",
      "september",
      "oktober",
      "november",
      "december"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%Y-%m-%d",
  "time24": "%H:%M:%S",
  "dateTime": "%a %e %b %Y %H:%M:%S",
  "time12": "",
  "full": "%a %e %b %Y %H:%M:%S %Z"
}

